import { api as adminApi, apiHooks as adminApiHooks } from "./admin/api.js";
import { api as adminPersonApi } from "./adminPerson/api.js";
import {
  api as assessmentApi,
  apiHooks as assessmentApiHooks,
} from "./assessment/api.js";
import {
  api as assessmentActivityApi,
  apiHooks as assessmentActivityApiHooks,
} from "./assessmentActivity/api.js";
import {
  api as auditTrailApi,
  apiHooks as auditTrailApiHooks,
} from "./auditTrail/api.js";
import { apiAxios } from "./axios/api.js";
import {
  api as configurationApi,
  apiHooks as configurationApiHooks,
} from "./configuration/api.js";
import { api as formDraftApi } from "./formDraft/api.js";
import { api as instrumentApi } from "./instrument/api.js";
import {
  api as involvementApi,
  apiHooks as involvementApiHooks,
} from "./involvement/api.js";
import {
  api as organisationApi,
  apiHooks as organisationApiHooks,
} from "./organisation/api.js";
import { api as personApi, apiHooks as personApiHooks } from "./person/api.js";
import {
  api as personActivityApi,
  apiHooks as personActivityApiHooks,
} from "./personActivity/api.js";
import {
  api as personGuestApi,
  apiHooks as personGuestApiHooks,
} from "./personGuest/api.js";
import { api as userApi, apiHooks as userApiHooks } from "./user/api.js";
import {
  api as waitingWorkApi,
  apiHooks as waitingWorkApiHooks,
} from "./waitingWork/api.js";

export const apiHooks = {
  ...userApiHooks(),
  ...adminApiHooks(),
  ...auditTrailApiHooks(),
  ...personApiHooks(),
  ...personActivityApiHooks(),
  ...configurationApiHooks(),
  ...involvementApiHooks(),
  ...organisationApiHooks(),
  ...assessmentApiHooks(),
  ...assessmentActivityApiHooks(),
  ...personGuestApiHooks(),
  ...waitingWorkApiHooks(),
};

export default {
  ...userApi(apiAxios),
  ...adminApi(apiAxios),
  ...auditTrailApi(apiAxios),
  ...personApi(apiAxios),
  ...personActivityApi(apiAxios),
  ...configurationApi(apiAxios),
  ...involvementApi(apiAxios),
  ...adminPersonApi(apiAxios),
  ...organisationApi(apiAxios),
  ...assessmentApi(apiAxios),
  ...assessmentActivityApi(apiAxios),
  ...instrumentApi(apiAxios),
  ...formDraftApi(apiAxios),
  ...personGuestApi(apiAxios),
  ...waitingWorkApi(apiAxios),
};
